import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export const AboutCountryIreland = () => {
  const navigate = useNavigate();

  const IrelandData = {
    title: "Study Abroad Opportunities Ireland",
    mTitle: "Why Study in the Ireland?",
    desc_1:
      "The United States stands as a global leader in higher education, offering an unparalleled diversity of academic programs and institutions. With its cutting-edge research facilities, innovative teaching methods, and strong support for international students, studying in the Ireland opens doors to global opportunities.",
    desc_2:
      "In the Ireland, you’ll find not only academic excellence but also a diverse cultural environment, internships, and strong industry ties. It’s more than education—it’s a life experience.",
  };

  const IrelandBenefits = [
    { title: "World-Class Education", number: 550, suffix: "+" },
    { title: "Diverse Academic Programs", number: 100, suffix: "%" },
    { title: "Top-Ranked Universities", number: 300, suffix: "+" },
    { title: "Strong Industry Connections", number: 550, suffix: "+" },
  ];

  const IrelandUniversities = [
  
  // 🇮🇪 Ireland
  {
    title: "Maynooth University",
    country: "Ireland",
    img: "/image/study-abroad/europe/maynooth-university.png",
    link: "#",
  },
  {
    title: "TU Dublin",
    country: "Ireland",
    img: "/image/study-abroad/europe/tu-dublin.png",
    link: "#",
  },
  {
    title: "National College of Ireland",
    country: "Ireland",
    img: "/image/study-abroad/europe/national-college-of-ireland.png",
    link: "#",
  },
  {
    title: "University of Ireland Galway",
    country: "Ireland",
    img: "/image/study-abroad/europe/university-of-ireland-galway.png",
    link: "#",
  },
  {
    title: "Trinity College Dublin",
    country: "Ireland",
    img: "/image/study-abroad/europe/trinity-college-dublin.png",
    link: "#",
  },
  {
    title: "IBAT College Dublin",
    country: "Ireland",
    img: "/image/study-abroad/europe/ibat-college-dublin.png",
    link: "#",
  },
];


  const responsiveCarousel = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
    tablet: { breakpoint: { max: 1024, min: 600 }, items: 2 },
    mobile: { breakpoint: { max: 600, min: 0 }, items: 1 },
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
        <style>
        {`
          .react-multiple-carousel__arrow {
            margin-left: -45px;
            margin-right: -45px;
          }
          
        `}
      </style>

      {/* Hero Section */}
      <section className="mb-10">
        <h1 className="text-4xl font-bold text-indigo-700 mb-6">
          {IrelandData.title}
        </h1>

        {/* Carousel After Main Title */}
        <div className="mb-10 mt-10">
<h3 className="text-2xl font-semibold text-indigo-600 mb-5 mt-5">Top Universities in the Ireland</h3>
        <p className="text-gray-600 mb-5 mt-5">Explore Our Partner Institutions</p>

             <Carousel
            responsive={responsiveCarousel}
            infinite
            autoPlay
            autoPlaySpeed={4000}
            arrows
            keyBoardControl
            showDots={false}
            containerClass="carousel-container-custom"
            itemClass="px-3"
            renderButtonGroupOutside={false}
          >
            {IrelandUniversities.map((univ, idx) => {
              const content = (
                <div className="bg-white mt-10 rounded-lg shadow hover:shadow-lg transition-all duration-300 p-4 text-center h-full flex flex-col items-center justify-between">
                  <img
                    src={univ.img}
                    alt={univ.title}
                    className="rounded-md max-h-36 w-full object-contain mb-3"
                    loading="lazy"
                  />
                  <h5 className="text-sm font-medium text-gray-700">{univ.title}</h5>
                </div>
              );
              return univ.link ? (
                <Link key={idx} to={univ.link}>
                  {content}
                </Link>
              ) : (
                <div key={idx}>{content}</div>
              );
            })}
          </Carousel>

        </div>

        {/* Rest of the Section */}
        <h2 className="text-2xl text-indigo-600 font-semibold mb-4">{IrelandData.mTitle}</h2>
        <p className="text-gray-700 mb-3 leading-relaxed">{IrelandData.desc_1}</p>
        <p className="text-gray-700 leading-relaxed">{IrelandData.desc_2}</p>
     
          <img
          src="/image/about/about-07/ireland.png"
          alt="Study in Ireland"
          className="w-[30%] h-[30%] mx-auto mt-6 rounded-lg object-cover shadow"
        />
        
      </section>

      {/* Features Section */}
      <section className="mb-16">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">Key Benefits of Studying in the Ireland</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {IrelandBenefits.map((item, idx) => (
            <div key={idx} className="bg-white p-6 rounded-xl shadow-md text-center border border-gray-100">
              <div className="text-3xl font-bold text-indigo-600">
                {item.number}
                {item.suffix}
              </div>
              <p className="mt-2 text-lg font-medium text-gray-700">{item.title}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <div className="text-center mt-12">
        <button
          onClick={() => navigate("/contact-us")}
          className="bg-indigo-600 text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-indigo-700 transition"
        >
          Apply Now!
        </button>
      </div>
    </div>
  );
};

export default AboutCountryIreland;
